import { ConnectedDeleteFormConfirmationModal } from 'components/Workspaces/Batch/DeleteFormConfirmationModal/DeleteFormConfirmationModal';
import { ConnectedMultipleApply } from 'components/Workspaces/Batch/MultipleApply/MultipleApply';
import { TabIdProps } from 'shared/props';
import styled from 'styled-components';

import { BatchToolbarFormActions } from './BatchToolbarFormActions/BatchToolbarFormActions';
import { BatchToolbarMetadata } from './BatchToolbarMetadata/BatchToolbarMetadata';
import { BatchToolbarWorkspaceActions } from './BatchToolbarWorkspaceActions/BatchToolbarWorkspaceActions';

const StyledDivContainer = styled.div`
  height: 56px;
  border: 1px;
  border-bottom-style: solid;
  border-bottom-color: rgba(149, 161, 162, 0.4);
  z-index: 6;
`;

export function BatchToolbar({ tabId }: TabIdProps) {
  return (
    <StyledDivContainer
      className="batch-toolbar-component d-flex bg-lvl1 px-2 px-md-4 w-100 shadow-sm"
      data-e2e="batch-toolbar"
    >
      <ConnectedMultipleApply tabId={tabId} />
      <BatchToolbarWorkspaceActions tabId={tabId} />
      <BatchToolbarMetadata tabId={tabId} />
      <BatchToolbarFormActions tabId={tabId} />
      <ConnectedDeleteFormConfirmationModal tabId={tabId} />
    </StyledDivContainer>
  );
}
